module.exports = __webpack_public_path__ + "img/1440.6623f9a3.jpg";